import { GridEvent } from '../models/grid-event-state.model';

export class SetGridEvent {
  static readonly type = '[GRID EVENT] Set grid event';

  constructor(public payload: GridEvent) {
  }
}
